import styled from 'styled-components'

interface GlobalSearchResultTabStyledProps {
  isSelected: boolean
}

export const GlobalSearchResultTabStyled = styled.button.attrs({
  type: 'button',
})<GlobalSearchResultTabStyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.typography.pxToRem(12)};
  border-radius: ${(props) => props.theme.typography.pxToRem(16)};
  font-family: inherit;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  line-height: ${(props) => props.theme.typography.pxToRem(16)};
  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;

  background: ${(props) =>
    props.isSelected ? props.theme.colors.primary : 'transparent'};
  color: ${(props) =>
    props.isSelected
      ? props.theme.colors.text.inverse
      : props.theme.colors.text.secondary};
  border: none;
  box-shadow: ${(props) =>
    props.isSelected
      ? 'none'
      : `0px 0px 0px 1px ${props.theme.colors.content.border} inset`};
`
